import { render, staticRenderFns } from "./StartupsGrid.vue?vue&type=template&id=d58b9cc6&scoped=true&"
import script from "./StartupsGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsGrid.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58b9cc6",
  null
  
)

export default component.exports